module.exports = __webpack_public_path__ + "img/fujilogo-p-2000.f9ea4d21.png";